

























import Webview from '@/webview';
import { Prop, Component } from 'vue-property-decorator';
import { IServicePackListItem } from '@/store/specialist/index.d';

@Component
export default class SpecialistDetail extends Webview {
  @Prop({
    type: Object,
    default: () => null
  })
  pack!: IServicePackListItem;

  @Prop({ default: false }) isLast!: boolean;

  get equityDesc() {
    const equityItemList = this.pack.equityItemList || [];
    return equityItemList.reduce((res: string, item) => {
      const { equityItemName } = item;
      return `${res + equityItemName} `;
    }, '');
  }

  goPacks(packId: number) {
    this.adapter.redirect(
      `${process.env.VUE_APP_STATIC}/f2e/special-disease-service/#/service/detail?servicePackId=${packId}`
    );
  }
}
